
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
  import {
    commissionWithdrawalwithdrawalpageinit,
    commissionWithdrawalcheckFail,
    commissionWithdrawalcheckSuccess
  } from "@/api/finance"
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private radioType = 0;
		private radioList: any = [{
				label: '待审核',
				value: 0
			},{
				label: '打款中',
				value: 3
			}, {
				label: '已通过',
				value: 1
			}, {
				label: '已驳回',
				value: 2
			}, 
		];
    private grade = null
    private gradelist = [
      {
				label: '全部',
				value: null
			}, {
				label: '总代',
				value: 3
			}, {
				label: '核心',
				value: 2
			}, {
				label: '联创',
				value: 1
			}
    ]
    private WithdrawalType = null
    private WithdrawalTypelist = [
      {value:null,label:'全部'},
      {value:0,label:'银行卡'},
      {value:1,label:'支付宝'},
      {value:2,label:'微信零钱'},
    ]
    private keywords = ''
    private filterTime:any = {
      time1:'',
      time2:'',
      time3:'',
      time4:''
    }
    private tablelist:any = [{}]
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;


    private rowmsg:any = {}
    private reject:any = {
      show:false,
      reason:'',
      isbatch:false,
      progress:1,
      type:'notice',
      title:'驳回提现申请'
    }
    private pass:any = {
      show:false,
      isbatch:false,
      progress:1,
    }
    private chooselist:any = []
    private dealwithshow = false
    private dealwithfail = 0
    private alllength = 0

    private res:any = {}

    private mounted () {

      this.radioList.map((v,i)=>{
        if(this.radioType==i){
          this.filterTime['time'+(i+1)] = ''
        }else{
          this.filterTime['time'+(i+1)] = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
        }
      })
      // console.log(this.filterTime)
      this.gettablelist()
    }


    private closefinish(){
      this.chooselist = []
      if(this.radioType==0){
        this.$nextTick(()=>{
          (this as any).$refs.table.clearSelection()
        })
      }
    }
    private selectable(row){
      return !row.IsPaying
    }
    private topass(row){
      this.rowmsg = row
      this.pass = {
        show:true,
        isbatch:false,
        progress:1
      }
    }
    private async confirmpass(){
      if(!this.pass.isbatch){
        this.onceconfirmpass()
      }else{
        this.batchconfirmpass()
      }
      this.alllength = this.chooselist.length
    }
    private async onceconfirmpass(){
      try{
        this.tableloading = true
        let data = {
          CommissionWithdrawalInfoList:[{
            Id:this.rowmsg.Id,
            WithdrawalMoney:this.rowmsg.ApplyWithdrawalMoney
          }]
        }
        let res = await commissionWithdrawalcheckSuccess(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.pageNo = 1
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async batchconfirmpass(){
      try{
        this.tableloading = true
        let data = {
          CommissionWithdrawalInfoList:this.chooselist.map(v=>{
            return {
              Id:v.Id,
              WithdrawalMoney:v.ApplyWithdrawalMoney
            }
          })
        }
        let res = await commissionWithdrawalcheckSuccess(data)
        this.dealwithfail = this.alllength - res.Result.SuccessCount
        this.dealwithshow = true
        if(res.IsSuccess){
          this.pageNo = 1
        }
      }finally{
        this.gettablelist()
        this.tableloading = false
      }
    }
    private batchpass(){
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请先选择要操作的对象')
        return
      }
      this.pass = {
        show:true,
        isbatch:true,
        progress:1
      }
    }
    private batchreject(){
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请先选择要操作的对象')
        return
      }
      this.alllength = this.chooselist.length
      this.reject = {
        show:true,
        reason:'',
        isbatch:true,
        progress:1,
        type:'notice',
        title:'驳回提现申请'
      }
    }
    private async confirmreject(){
      if(!this.reject.reason){
        this.$message.error('输入驳回原因')
        return
      }
      try{
        this.tableloading = true
        let data:any = {
          IdList:[],
          FailReason:this.reject.reason
        }
        data.IdList = this.reject.isbatch?this.chooselist.map(v=>v.Id):[this.rowmsg.Id]
        this.reject.show = false
        let res = await commissionWithdrawalcheckFail(data)
        if(res.IsSuccess){
          this.pageNo = 1
          if(this.reject.isbatch){
            this.dealwithfail = this.alllength - res.Result.SuccessCount
            this.dealwithshow = true
          }else{
            this.$message.success('操作成功')
          }
          // this.gettablelist()
        }
      }finally{
        this.gettablelist()
        this.tableloading = false
        // this.$nextTick(()=>{
        //   (this as any).$refs.table.clearSelection()
        // })
      }
    }
    private toreject(row){
      this.rowmsg = row
      this.reject = {
        show:true,
        reason:'',
        isbatch:false,
        progress:1,
        type:'notice',
        title:'驳回提现申请'
      }
    }
    private selectionchange(list){
      this.chooselist = list
    }
    private exportlist(){
      let url = location.origin + '/pc/commissionWithdrawal/withdrawalexport'
      url += '?Keywords=' + this.keywords
      url += '&WithdrawalType=' + (this.WithdrawalType==null?'':this.WithdrawalType)
      url += '&RoleGrade=' + (this.grade==null?'':this.grade)
      url += '&WithdrawalState=' + this.radioType
      if (this.filterTime['time'+(this.radioType+1)]){
        var splitList = this.filterTime['time'+(this.radioType+1)].split('/');
        url += '&StartTime=' + (splitList[0]||'')
        url += '&EndTime=' + (splitList[1] ? (nextDay(splitList[1],1)) : '')
      }
      // console.log(url)
      window.open(url)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          WithdrawalState:this.radioType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          WithdrawalType:this.WithdrawalType,
          RoleGrade:this.grade,
        }
        if (this.filterTime['time'+(this.radioType+1)]){
					var splitList = this.filterTime['time'+(this.radioType+1)].split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await commissionWithdrawalwithdrawalpageinit(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.AccountInfolist = v.AccountInfo.split(',')
            return v
          })
          // this.tablelist = [
          //   {Id:1,WithdrawalState:0,Name:'待审核一号',IsPaying:false},
          //   {Id:2,WithdrawalState:0,Name:'待审核二号',IsPaying:false},
          //   {Id:3,WithdrawalState:0,Name:'待审核三号',IsPaying:true},
          //   {Id:4,WithdrawalState:0,Name:'待审核四号',IsPaying:true},
          //   {Id:5,WithdrawalState:0,Name:'待审核五号',IsPaying:false},
          //   {Id:6,WithdrawalState:0,Name:'待审核六号',IsPaying:false},
          // ]
          this.total = res.Result.Total
          this.res = res.Result
          this.$nextTick(()=>{
            if(this.radioType==0){
              (this as any).$refs.table.clearSelection()
            }
            (this as any).$refs.table.doLayout()
          })
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.WithdrawalType = null
      this.grade = null
      if(this.radioType==0){
        this.filterTime['time'+(this.radioType+1)] = ''
      }else{
        this.filterTime['time'+(this.radioType+1)] = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      }
      this.doSearch()
    }
    private changetype(e){
      this.doSearch()
    }
  }
